'use strict';

wbApp.controller('RentCtrl', ['$scope', '$q', '$window', '$modal', '$translate', '$timeout', 'urlUtils', 'itemTypeSvc', 'rentCategorySvc', 'rentSvc',
    'classroomAvailabilitySchedulesSvc', 'notificationSvc', 'rentItemAvailabilitySvc', 'securitySvc', 'messageBoxSvc', 'rentItemSvc', 'localStorageService',
    'shoppingCartSvc',
function ($scope, $q, $window, $modal, $translate, $timeout, urlUtils, itemTypeSvc, rentCategorySvc, rentSvc,
    classroomAvailabilitySchedulesSvc, notificationSvc, rentItemAvailabilitySvc, securitySvc, messageBoxSvc, rentItemSvc, localStorageService,
    shoppingCartSvc) {

    var schedulerInstanceDeferred = $q.defer();

    DevExpress.localization.loadMessages({
        "cs": {
            "dxScheduler-switcherWeek": "Týden"
        },
        "en": {
            "dxScheduler-switcherWeek": "Week"
        }
    });

    $scope.selectedResourceId = null;
    $scope.selectedResource = {};

    $scope.onResourceHeaderClick = function (resourceId) {
        $scope.selectedResourceId = resourceId;
        $scope.rentItems.$promise.then(function () {
            $scope.selectedResource = _.find($scope.rentItems, { id: resourceId });
        });
    }

    var currentView = null;
    var lastStartDate = null;
    var lastEndDate = null;

    var reloadData = true;
    var repaintAfterReload = false;
    var lastDataLoadPlaceId;
    var lastDataLoadRentCategoryId;
    var lastDataLoadItemTypeId;
    var lastDataLoadUserID;
    var lastDataLoadStartDate;
    var lastDataLoadEndDate;
    var lastLoadedData;
    var dataLoadedAt;

    var scheduleDataSource = new DevExpress.data.DataSource({
        store: new DevExpress.data.CustomStore({
            load: function (loadOptions) {
                return $q(function (resolve, reject) {
                    $scope.rentCategory.$promise.then(function () {

                        if (!$scope.itemToRent || !$scope.itemToRent.itemTypeId) {
                            resolve([]);
                            return;
                        }

                        var rentsPromise = null;
                        var classroomAvailabilitySchedulesPromise = null;
                        var rentItemAvailabilityPromise = null;

                        var promises = [];

                        var currentViewChanged = currentView !== schedulerInstance.option("currentView");
                        var mstartDate = moment(schedulerInstance.getStartViewDate()).startOf('day');
                        var mendDate = moment(schedulerInstance.getEndViewDate()).endOf('day');
                        var dateRangeChanged = !mstartDate.isSame(lastStartDate) || !mendDate.isSame(lastEndDate);

                        if (currentViewChanged || dateRangeChanged) {
                            currentView = schedulerInstance.option("currentView");
                            lastStartDate = mstartDate.toDate();
                            lastEndDate = mendDate.toDate();

                            classroomAvailabilitySchedulesPromise = classroomAvailabilitySchedulesSvc.loadPeriod(
                                $scope.placeId,
                                lastStartDate,
                                lastEndDate);
                            promises.push(classroomAvailabilitySchedulesPromise);
                        }

                        if (currentViewChanged || dateRangeChanged ||
                           (lastDataLoadItemTypeId != $scope.itemToRent.itemTypeId) ||
                            repaintAfterReload) {

                            if (!!$scope.itemToRent.itemTypeId) {

                                repaintAfterReload = false;

                                var groupBy = "GroupByRentCategory";
                                switch ($scope.rentCategory.itemSelectionType) {
                                    case 0:
                                        groupBy = "GroupByRentItem"
                                        break;
                                    case 1:
                                        groupBy = "GroupByRentCategory"
                                        break;
                                }

                                rentItemAvailabilityPromise = rentItemAvailabilitySvc.getAllByPlaceAndRentCategoryAndTypeAndDateRange(
                                    $scope.placeId,
                                    $scope.rentCategoryId,
                                    $scope.itemToRent.itemTypeId,
                                    lastStartDate,
                                    lastEndDate,
                                    groupBy);
                                promises.push(rentItemAvailabilityPromise.$promise);
                            }
                        }

                        reloadData = reloadData ||
                            lastDataLoadPlaceId != $scope.placeId ||
                            lastDataLoadRentCategoryId != $scope.rentCategoryId ||
                            lastDataLoadItemTypeId != $scope.itemToRent.itemTypeId ||
                            lastDataLoadUserID != securitySvc.loggedInUser().userID ||
                            !moment(lastDataLoadStartDate).isSame(lastStartDate) ||
                            !moment(lastDataLoadEndDate).isSame(lastEndDate) ||
                             moment().diff(dataLoadedAt, 'seconds') > 10;

                        if (securitySvc.isAuthenticated()) {
                            if (reloadData) {
                                rentsPromise = securitySvc.isInRole('Rent')
                                    ? rentSvc.getAllByPlaceAndRentCategoryAndTypeAndDateRange(
                                        $scope.placeId,
                                        $scope.rentCategoryId,
                                        $scope.itemToRent.itemTypeId,
                                        lastStartDate,
                                        lastEndDate).$promise
                                    : rentSvc.getAllByPlaceAndRentCategoryAndTypeAndUserDateRange(
                                        $scope.placeId,
                                        $scope.rentCategoryId,
                                        $scope.itemToRent.itemTypeId,
                                        securitySvc.loggedInUser().userID,
                                        lastStartDate,
                                        lastEndDate).$promise;
                                promises.push(rentsPromise);

                                lastDataLoadPlaceId = $scope.placeId;
                                lastDataLoadRentCategoryId = $scope.rentCategoryId;
                                lastDataLoadItemTypeId = $scope.itemToRent.itemTypeId;
                                lastDataLoadUserID = securitySvc.loggedInUser().userID;
                                lastDataLoadStartDate = lastStartDate;
                                lastDataLoadEndDate = lastEndDate;
                                reloadData = false;

                                lastLoadedData = rentsPromise;
                                dataLoadedAt = moment();
                            } else {
                                rentsPromise = lastLoadedData;
                                promises.push(rentsPromise);
                            }
                        }

                        $q.all(promises).then(function (resolvedPromisses) {

                            var shouldRepaint = false;

                            if (!!rentItemAvailabilityPromise) {
                                shouldRepaint = true;
                                if (!$scope.itemToRent.itemTypeId) {
                                    itemAvailability = null;
                                } else {
                                    itemAvailability = rentItemAvailabilityPromise;                                    
                                   // schedulerInstance.repaint();
                                }
                            }

                            if (!!classroomAvailabilitySchedulesPromise) {
                                shouldRepaint = true;
                                var schedules = resolvedPromisses[0];
                                if (!$scope.itemToRent.itemTypeId) {                                    
                                    classroomAvailabilitySchedules = schedules;
                                    setStartAndEndDayHour(schedules);
                                    setCellDuration();
                                } else {
                                    classroomAvailabilitySchedules = schedules;
                                    setStartAndEndDayHour(schedules);
                                    setCellDuration();
                                }
                            }

                            if (shouldRepaint) {
                                $timeout(function () { schedulerInstance.repaint() }, 1);
                            }

                            if (!!rentsPromise) {

                                rentsPromise.then(function (rents) {
                                    if ($scope.rentCategory.itemSelectionType == 0) { /* Manual */
                                        var result = _.flatMap(rents, function (rentItem) {
                                            return _.map(rentItem.rentedItems, function (rentedItem) {
                                                var subRentItem = _.assign({}, rentItem, rentedItem, {
                                                    id: rentItem.id + '-' + rentedItem.id,
                                                    rentItemId: rentedItem.id
                                                });
                                                if (subRentItem.rentingPeriodType == 1) { // Days
                                                    subRentItem.toUtcOrig = subRentItem.toUtc;
                                                    subRentItem.toUtc = moment(subRentItem.toUtc).subtract(1, 'day').toDate();
                                                }
                                                return subRentItem;
                                            });
                                        });
                                        resolve(result);
                                    } else {
                                        resolve(rents);
                                    }
                                });
                            } else {
                                resolve([]);
                            }
                        }, function(error) {
                            reject(error);
                        });
                    });
                })
            },
            loadMode: 'processed'
        })
    });

    var rentItemsDataSource = new DevExpress.data.DataSource({
        store: new DevExpress.data.CustomStore({
            load: function (loadOptions) {
                return $q(function (resolve, reject) {
                    $q.all($scope.rentCategory.$promise,
                        $scope.rentItems.$promise).then(function () {
                            if ($scope.rentCategory.itemSelectionType == 0  && /* Manual */
                                !!$scope.selectedItemType) {

                                var filteredRentItems = _.orderBy(_.filter($scope.rentItems, { itemTypeId: $scope.selectedItemType.id }), ['name'], ['asc']);

                                if (!$scope.selectedResourceId && filteredRentItems.length > 0) {
                                    $scope.onResourceHeaderClick(filteredRentItems[0].id);
                                }

                                resolve(filteredRentItems);
                            }
                            else {
                                resolve([]);
                            }
                    }, function() {
                        reject();
                    });
                })
            },
            loadMode: 'processed'
        })
    });

    $scope.tabs = [];
    $scope.categories = [];
    $scope.itemSelectionType = 0;

    $scope.rentCategoryId = urlUtils.getQueryParams()['rentCategoryId'];
    $scope.placeId = urlUtils.getQueryParams()['placeId'];

    $scope.cart = shoppingCartSvc.loadShoppingCart($scope.placeId);

    $scope.itemToRent = {        
        rentCategoryId: $scope.rentCategoryId,
        itemTypeId: localStorageService.get('selected-item-type-' + $scope.rentCategoryId)
    };

    var originalItemTypeId = $scope.itemToRent.itemTypeId;

    var schedulerInstance = null;    

    var itemTypes = itemTypeSvc.getByPlaceAndRentCategory($scope.placeId, $scope.rentCategoryId);

    $scope.place = {};

    $scope.rentCategory = rentCategorySvc.getById($scope.rentCategoryId);
    $scope.rentItems = rentItemSvc.getAllByPlaceAndRentCategory($scope.placeId, $scope.rentCategoryId);

    function switchView(itemSelectionType, rentingPeriodType) {
        switch (itemSelectionType) {
            case 0: /* Manual */
                if (rentingPeriodType == 0) {
                    // minutes
                    schedulerInstance.option('currentView', 'timelineDay');
                } else {
                    // days
                    schedulerInstance.option('currentView', 'month');
                }
                break;
            case 1: /* Automatic */
                schedulerInstance.option('currentView', 'week');
                break;
        }
    }

    function PrepareTabs() {

        $scope.rentCategory.$promise.then(function () {

            $scope.itemSelectionType = $scope.rentCategory.itemSelectionType;
            $scope.rentingPeriodType = $scope.rentCategory.rentingPeriodType;

            if ($scope.itemSelectionType == 0 /* Manual */) {
                $scope.tabs.push({
                    title: $scope.rentCategory.name,
                    template: "rents/rent-manual-selection-tab.html",
                });
            } else {
                $scope.tabs.push({
                    title: $scope.rentCategory.name,
                    template: "rents/rent-automatic-selection-tab.html",
                });
            }            
        });
    }

    PrepareTabs();

    function setUpViews(itemSelectionType, rentingPeriodType) {

        switch (itemSelectionType) {
            case 0:    /* Manual */
                if (rentingPeriodType == 0) { // minutes
                    schedulerInstance.option('views').push({
                        type: "week",
                        startDayHour: 1,
                        appointmentTemplate: function (data, index, element) {
                            var cell = $(".dx-scheduler-date-table-cell");
                            element.parent().css("min-width", cell.width());
                            if (data.appointmentData.userId == securitySvc.loggedInUser().userID) {
                                element.parent().addClass('own-appointment');
                            }
                            return "item";
                        },
                        resourceCellTemplate: 'resourceCellTemplate'
                    });
                    schedulerInstance.option('views').push({
                        type: "timelineDay",
                        appointmentTemplate: function (data, index, element) {
                            var cell = $(".dx-scheduler-date-table-cell");
                            element.parent().css("top", (cell.height() - 100) / 2);
                            if (data.appointmentData.userId == securitySvc.loggedInUser().userID) {
                                element.parent().addClass('own-appointment');
                            }
                            return "item";
                        },
                        resourceCellTemplate: 'resourceCellTemplate'
                    });
                } else { // Days
                    schedulerInstance.option('views').push({
                        type: "month",
                        startDayHour: 1,
                        groupOrientation: "vertical",
                        appointmentTemplate: function (data, index, element) {
                            var cell = $(".dx-scheduler-date-table-cell");
                            element.parent().css("min-width", cell.width());
                            if (data.appointmentData.userId == securitySvc.loggedInUser().userID) {
                                element.parent().addClass('own-appointment');
                            }
                            return "item";
                        },
                        resourceCellTemplate: 'resourceCellTemplate'
                    });
                    schedulerInstance.option('views').push({
                        type: "timelineMonth",
                        appointmentTemplate: function (data, index, element) {
                            var cell = $(".dx-scheduler-date-table-cell");
                            element.parent().css("top", (cell.height() - 100) / 2);
                            if (data.appointmentData.userId == securitySvc.loggedInUser().userID) {
                                element.parent().addClass('own-appointment');
                            }
                            return "item";
                        },
                        resourceCellTemplate: 'resourceCellTemplate'
                    });
                }
                schedulerInstance.option('groups').push('rentItemId');
                break;
            case 1:    /* Automatic */
                schedulerInstance.option('views').push({
                    type: "week",
                    startDayHour: 1,
                    appointmentTemplate: function (data, index, element) {
                        //var cell = $(".dx-scheduler-date-table-cell");
                        if (data.appointmentData.userId == securitySvc.loggedInUser().userID)
                        {
                            element.parent().addClass('own-appointment');
                        }
                       // element.parent().css("min-width", cell.width());
                        return "item";
                    },
                    resourceCellTemplate: 'resourceCellTemplate'
                });
                break;
        }

    }

    var lastStartDate = moment().startOf('isoWeek').toDate();

    function getStartAndEndDayHourForSingleSchedule(schedule) {
        if (schedule.periods && schedule.periods.length > 0)
        {
            return { 
                startDayHour: moment(_.first(schedule.periods).start).hour(),
                endDayHour: Math.min(24, moment(_.last(schedule.periods).end).hour() + 1)
            };
        }

        return { startDayHour: 24, endDayHour: 0 };
    }

    
    var classroomAvailabilitySchedules = null;
    var itemAvailability = null;

    function setCellDuration() {
        $scope.rentCategory.$promise.then(function () {

            switch ($scope.rentCategory.rentingPeriodType) {
                case 0:   // Minutes
                    switch ($scope.rentCategory.rentHourStartType) {
                        case 0:   //AtAnyTime,
                            schedulerInstance.option('cellDuration', 30);
                            break;
                        case 1:   //AtWholeHourOnly,
                            schedulerInstance.option('cellDuration', 60);
                            break;
                        case 2:   //AtHalfHourOnly,
                            schedulerInstance.option('cellDuration', 30);
                            break;
                        case 3:   //AtHalfOrFullHour
                            schedulerInstance.option('cellDuration', 30);
                            break;
                    }
                    break;
                case 1:   // WholeCallendarDays
                    break;
            }


            switch($scope.rentCategory.rentingPeriodType)
            {
                case 0:   // Minutes
                    if ($scope.rentCategory.minimumRentingPeriods <= 30) {
                        schedulerInstance.option('cellDuration', 30);
                    } else if ($scope.rentCategory.minimumRentingPeriods > 30 &&
                               $scope.rentCategory.minimumRentingPeriods <= 60) {
                        schedulerInstance.option('cellDuration', 30);
                    } else {
                        schedulerInstance.option('cellDuration', 30);
                    }
                    break;
                case 1:   // WholeCallendarDays
                    break;
            }

        });
    }

    function getStartAndEndDayHour(classroomAvailabilitySchedules) {
        var startAndEndDayPeriods = _.map(classroomAvailabilitySchedules, getStartAndEndDayHourForSingleSchedule);
        var start = _.minBy(startAndEndDayPeriods, 'startDayHour');
        var end = _.maxBy(startAndEndDayPeriods, 'endDayHour');

        if (start.startDayHour == 24) {
            return { startDayHour: 8, endDayHour: 17 }; // Default
        } else {
            return { startDayHour: start.startDayHour, endDayHour: end.endDayHour };
        }
    }

    function setStartAndEndDayHour(schedules) {

        if (!!schedules) {
            var setting = getStartAndEndDayHour(schedules);

            schedulerInstance.option('views[0].startDayHour', setting.startDayHour);
            schedulerInstance.option('views[0].endDayHour', setting.endDayHour);

            if ($scope.rentCategory.itemSelectionType == 0) {
                schedulerInstance.option('views[1].startDayHour', setting.startDayHour);
                schedulerInstance.option('views[1].endDayHour', setting.endDayHour);
            }
        } else {
            console.error('setStartAndEndDayHour not applied: !!classroomAvailabilitySchedules: ' + !!classroomAvailabilitySchedules + ' !!schedulerInstance:' + !!schedulerInstance);
        }
    }

    function isValidAppointment(appointmentData, showNotification) {
        var startDate = appointmentData.startDate;
        if (moment().isAfter(startDate)) {
            if (showNotification) {
                notificationSvc.notifyWarning(
                    $translate.instant('TXT_INVALID_SELECTION') + ':',
                    $translate.instant('TXT_CANNOT_CREATE_RENT_INT_THE_PAST'));
            }
            return false;
        }

        var mStartDate = moment(startDate);
        var mEndDate = moment(appointmentData.endDate);
        

        if (!$scope.rentingPeriodType) { // minutes

            switch ($scope.rentCategory.rentHourStartType) {
                case 0:   //AtAnyTime,                    
                    break;
                case 1:   //AtWholeHourOnly,
                    if (mStartDate.minutes() != 0) {
                        if (showNotification) {
                            notificationSvc.notifyWarning(
                                $translate.instant('TXT_INVALID_SELECTION') + ':',
                                $translate.instant('TXT_RENT_CAN_START_AT_WHOLE_HOUR_ONLY'));
                        }
                        return false;
                    }
                    break;
                case 2:   //AtHalfHourOnly,
                    if (mStartDate.minutes() != 30) {
                        if (showNotification) {
                            notificationSvc.notifyWarning(
                                $translate.instant('TXT_INVALID_SELECTION') + ':',
                                $translate.instant('TXT_RENT_CAN_START_AT_HALF_HOUR_ONLY'));
                        }
                        return false;
                    }
                    break;
                case 3:   //AtHalfOrFullHour
                    if (mStartDate.minutes() != 30 || mStartDate.minutes() != 0) {
                        if (showNotification) {
                            notificationSvc.notifyWarning(
                                $translate.instant('TXT_INVALID_SELECTION') + ':',
                                $translate.instant('TXT_RENT_CAN_START_AT_HALF_OR_WHOLE_HOUR_ONLY'));
                        }
                        return false;
                    }
                    break;
            }

            var minutesDiff = mEndDate.diff(mStartDate, 'minutes');

            if (minutesDiff > $scope.rentCategory.maximumRentingPeriods) {
                if (showNotification) {
                    notificationSvc.notifyWarning(
                        $translate.instant('TXT_INVALID_SELECTION') + ':',
                        $translate.instant('TXT_RENT_TOO_LONG_MINUTES').f($scope.rentCategory.maximumRentingPeriods));
                }
                return false;
            }

            if (minutesDiff < $scope.rentCategory.minimumRentingPeriods) {
                if (showNotification) {
                    notificationSvc.notifyWarning(
                        $translate.instant('TXT_INVALID_SELECTION') + ':',
                        $translate.instant('TXT_RENT_TOO_SHORT_MINUTES').f($scope.rentCategory.minimumRentingPeriods));
                }
                return false;
            }

            if (!!classroomAvailabilitySchedules) {
                
                var mdate = moment(startDate).startOf('day');
                var schedule = _.find(classroomAvailabilitySchedules, function (s) {
                    return mdate.isSame(s.day);
                });
                if (!!schedule) {
                    var startDatePeriod = _.find(schedule.periods || [], function (p) {
                        return mStartDate.isBefore(p.end) && mStartDate.isSameOrAfter(p.start);
                    });
                    if (!!startDatePeriod) {
                        // Start date ok                        
                        mdate = moment(appointmentData.endDate).startOf('day');
                        schedule = _.find(classroomAvailabilitySchedules, function (s) {
                            return mdate.isSame(s.day);
                        });
                        if (!!schedule) {
                            var endDatePeriod = _.find(schedule.periods || [], function (p) {
                                return mEndDate.isSameOrBefore(p.end) && mEndDate.isAfter(p.start);
                            });
                        }
                        if (!!endDatePeriod) {
                            return true;
                        }
                    }
                }
            }
            if (showNotification) {
                notificationSvc.notifyWarning(
                    $translate.instant('TXT_INVALID_SELECTION') + ':',
                    $translate.instant('TXT_START_AND_DATE_MUST_BE_IN_OPEN_PERIOD'));
            }
        } else { // Days
            var numberOfDay = Math.ceil(mEndDate.diff(mStartDate, 'days', true));

            if (numberOfDay > $scope.rentCategory.maximumRentingPeriods) {
                if (showNotification) {
                    notificationSvc.notifyWarning(
                        $translate.instant('TXT_INVALID_SELECTION') + ':',
                        $translate.instant('TXT_RENT_TOO_LONG_DAYS').f($scope.rentCategory.maximumRentingPeriods));
                }
                return false;
            }

            if (numberOfDay < $scope.rentCategory.minimumRentingPeriods) {
                if (showNotification) {
                    notificationSvc.notifyWarning(
                        $translate.instant('TXT_INVALID_SELECTION') + ':',
                        $translate.instant('TXT_RENT_TOO_SHORT_DAYS').f($scope.rentCategory.minimumRentingPeriods));
                }
                return false;
            }

            return true;
        }

        return false;
    }

    function isDateAvailableAccordingToSchedule(date) {

        if (!!classroomAvailabilitySchedules) {
            var mdatetime = moment(date);

            if (moment().isAfter(date)) {
                return false;
            }

            var mdate = moment(mdatetime).startOf('day');

            var schedule = _.find(classroomAvailabilitySchedules, function (s) {
                return mdate.isSame(s.day);
            });

            if (!!schedule) {
                var period = _.find(schedule.periods || [], function (p) {
                    return mdatetime.isBefore(p.end) && mdatetime.isSameOrAfter(p.start);
                });

                return !!period;
            }

        }

        return false;
    }

    function isDateAvailableAccordingToItems(date, groups) {
        if (!!itemAvailability && !!$scope.rentCategory) {

            if ($scope.rentCategory.itemSelectionType == 1) { // Automatic
                var mdatetime = moment(date);

                var period = _.find(itemAvailability[$scope.rentCategory.id] || [], function (p) {
                    return mdatetime.isBefore(p.endUtc) && mdatetime.isSameOrAfter(p.startUtc);
                });

                if (!period) {
                    return 0;
                }

                return period.availableItemsCount;
            }
            else if ($scope.rentCategory.itemSelectionType == 0 && !!groups && !!groups.rentItemId) //  Manual
            {
                var period = null;

                if (!$scope.rentCategory.rentingPeriodType) {
                    // Minutes
                    var mdatetime = moment(date);

                    var period = _.find(itemAvailability[groups.rentItemId] || [], function (p) {
                        return mdatetime.isBefore(p.endUtc) && mdatetime.isSameOrAfter(p.startUtc);
                    });
                } else {
                    // Days
                    var mdatetime = moment(date);
                    var mdate = moment(date).startOf('day');

                    var period = _.find(itemAvailability[groups.rentItemId] || [], function (p) {

                        return mdate.isSameOrAfter(moment(p.startUtc).startOf('day')) &&
                        (mdate.isBefore(moment(p.endUtc).startOf('day')) ||
                           mdate.isSame(moment(p.endUtc).startOf('day')) &&
                           (moment(p.endUtc).hour() * 60 + moment(p.endUtc).minute() > ($scope.rentCategory.returnTimeTo || 12 * 60))
                        );
                    });
                }

                if (!period) {
                    return 0;
                }

                return period.availableItemsCount;
            }

        }

        return 0;
    }

    var selectedCells = null;

    $scope.schedulerOptions = {
        dataSource: scheduleDataSource,
        showAllDayPanel: false,       
        height: "auto",
        currentView: 'week',
        crossScrollingEnabled: true,
        views: [],
        resources: [{
            dataSource: rentItemsDataSource,
            fieldExpr: 'rentItemId',
            displayExpr: 'name',
            label: 'RentItem'
        }],
       // groups: ['rentItemId'],
        editing: {
            allowAdding: false,
            allowDeleting: false,
          //  allowDragging: false,
            allowTimeZoneEditing: false,
            allowResizing: false,
           // allowUpdating: false
        },
        onAppointmentAdding: function (e) {
            e.cancel = true;
        },
        onAppointmentFormOpening: function (e) {
            e.cancel = true;
        },
        onAppointmentUpdating: function (e) {
            e.cancel = true;
        },
        dataCellTemplate: function (itemData, itemIndex, itemElement) {
            var date = itemData.startDate;
            var isDisabled = !isDateAvailableAccordingToSchedule(date); 
            var availalbleCnt = isDateAvailableAccordingToItems(date, itemData.groups);

            var element = availalbleCnt == 0 || isDisabled
                ? $(`<div>${itemData.text}</div>`)
                : $scope.rentCategory.itemSelectionType == 1
                    ? $(`<div><div>${itemData.text}</div><div class='items-available-no'>${availalbleCnt}</div></div>`)
                    : $(`<div>${itemData.text}</div>`)

            if (isDisabled) {
                element.addClass('disable-date');
            }
            
            if (availalbleCnt > 5) {
                element.addClass('item-available-date-many');
            } else {
                element.addClass('item-available-date-' + availalbleCnt);
            }
            
            if (!!$scope.cart.rents) {
                var mdate = !$scope.rentCategory.rentingPeriodType
                    ? moment(date) // minutes
                    : moment(date).startOf('day'); // days
                _.forEach($scope.cart.rents, function (rent) {
                    var mendDate = !$scope.rentCategory.rentingPeriodType
                        ? rent.endDate // minutes
                        : moment(rent.endDate).startOf('day'); // days
                    var mstartDate = !$scope.rentCategory.rentingPeriodType
                        ? rent.startDate // minutes
                        : moment(rent.startDate).startOf('day'); // days

                    if (mdate.isBefore(mendDate) && mdate.isSameOrAfter(mstartDate)) {
                        if ($scope.rentCategory.itemSelectionType == 1) {
                            // Automatic selection
                            if (!!$scope.selectedItemType) {
                                if (!!_.find(rent.rentedItems || [], { rentCategoryId: $scope.rentCategory.id, itemTypeId: $scope.selectedItemType.id })) {
                                    element.addClass('shopping-cart-range');
                                }
                            }
                        } else if (!!itemData.groups) {
                            // Manual selection                                
                            if (!!_.find(rent.rentedItems || [], { id: itemData.groups.rentItemId, rentCategoryId: $scope.rentCategory.id})) {
                                element.addClass('shopping-cart-range');
                            }
                        }
                    }
                });
            }

            return itemElement.append(element);
        },
        onInitialized: function (e) {
            schedulerInstance = e.component;
            schedulerInstanceDeferred.resolve(schedulerInstance);

            setUpViews($scope.itemSelectionType, $scope.rentingPeriodType);
            switchView($scope.itemSelectionType, $scope.rentingPeriodType);

            e.element.on("mouseup", function (ee) {
                if ($(ee.target).is(".dx-scheduler-date-table-cell")) {
                    var data = {};

                    let selectedCells = schedulerInstance.option("selectedCellData");
                    
                    // selectedCells = $(ee.target).closest(".dx-scheduler-date-table").find(".dx-state-focused");
                    // if (selectedCells.length === 1) {
                    //     return;
                    // }


                    for (let i = 0; i < selectedCells.length; i++) {
                        let cellData = selectedCells[i];
                        if (cellData) {
                            if (!data.startDate || moment(data.startDate).isAfter(cellData.startDate)) {
                                data.startDate = cellData.startDate;
                            }
                            if (!data.endDate || moment(data.endDate).isBefore(cellData.endDate)) {
                                data.endDate = cellData.endDate;
                            }

                            if (!!cellData.groups && !!cellData.groups.rentItemId) {
                                data.rentItem = _.find($scope.rentItems, { 'id': cellData.groups.rentItemId });
                            }
                        }
                    }

                    if (isValidAppointment(data, true)) {
                        $scope.itemToRent.rentCategory = $scope.rentCategory;
                        $scope.itemToRent.numberOfItemsToAdd = 1;
                        $scope.itemToRent.rentItem = data.rentItem;


                        if ($scope.rentingPeriodType == 1) {
                            //Days
                            var startMinutes = $scope.rentCategory.pickupTimeFrom == null
                                ? $scope.rentCategory.pickupTimeTo == null
                                    ? 12 * 60
                                    : $scope.rentCategory.pickupTimeTo
                                : $scope.rentCategory.pickupTimeFrom;

                            $scope.itemToRent.startDate = moment(data.startDate).startOf('day').add(startMinutes, 'm').toDate();

                            var endMinutes = $scope.rentCategory.returnTimeTo == null
                                ? $scope.rentCategory.returnTimeFrom == null
                                    ? 12 * 60
                                    : $scope.rentCategory.returnTimeFrom
                                : $scope.rentCategory.returnTimeTo;

                            $scope.itemToRent.endDate = moment(data.endDate).startOf('day').add(endMinutes, 'm').add(1, 'day').toDate();
                        } else {
                            // Minutes
                            $scope.itemToRent.startDate = data.startDate;
                            $scope.itemToRent.endDate = data.endDate;
                        }

                        if (selectedCells) {

                            $(ee.target).find(".dx-state-focused").addClass("dx-state-selected");
                        }
                        openAddItemDialog($scope.itemToRent);
                    }

                }
            });
        },
        onCellClick: function (e) {
            var cellData = e.cellData;  // { "startDate", "endDate", "groups": { "rentItemId" } }

            var mStartDate = moment(cellData.startDate);
            var mEndDate = moment(cellData.endDate);

            var focusedCell = $(e.cellElement);
            selectedCells = focusedCell;

            if (!$scope.rentingPeriodType) { // minutes
                switch ($scope.rentCategory.rentHourStartType) {
                    case 0:   //AtAnyTime,                    
                        break;
                    case 1:   //AtWholeHourOnly,
                        if (mStartDate.minutes() != 0) {
                            mStartDate.startOf('hour');
                        }
                        break;
                    case 2:   //AtHalfHourOnly,
                        if (mStartDate.minutes() != 30) {
                            mStartDate.minute(30);
                        }
                        break;
                    case 3:   //AtHalfOrFullHour
                        if (mStartDate.minutes() != 30 || mStartDate.minutes() != 0) {
                            if (mStartDate.minutes() > 30) {
                                mStartDate.minute(30);
                            } else {
                                mStartDate.startOf('hour');
                            }
                        }
                        break;
                }

                var minutesDiff = mEndDate.diff(mStartDate, 'minutes');
                if (minutesDiff < $scope.rentCategory.minimumRentingPeriods) {
                    mEndDate = moment(mStartDate).add($scope.rentCategory.minimumRentingPeriods, 'm');
                }

                if (minutesDiff > $scope.rentCategory.maximumRentingPeriods) {
                    mEndDate = moment(mStartDate).add($scope.rentCategory.maximumRentingPeriods, 'm');
                }

                if (isValidAppointment({ startDate: mStartDate.toDate(), endDate: mEndDate.toDate() }, false)) {
                    $scope.itemToRent.rentCategory = $scope.rentCategory;
                    $scope.itemToRent.numberOfItemsToAdd = 1;
                    if (!!cellData.groups && !!cellData.groups.rentItemId) {
                        $scope.itemToRent.rentItem = _.find($scope.rentItems, { 'id': cellData.groups.rentItemId }); 
                        //cellData.groups.rentItemId;
                    }
                    $scope.itemToRent.startDate = mStartDate.toDate();
                    $scope.itemToRent.endDate = mEndDate.toDate();

                    if (selectedCells) {
                        if (schedulerInstance.option('currentView') == 'timelineDay') {
                            if (mStartDate.isBefore(cellData.startDate)) {
                                selectedCells = selectedCells.add(focusedCell.prev());
                            }

                            if (mEndDate.isAfter(cellData.endDate)) {
                                selectedCells = selectedCells.add(focusedCell.next());
                            }
                        } 

                        selectedCells.addClass("dx-state-selected");
                    }

                    openAddItemDialog($scope.itemToRent);
                } else {
                    e.cancel = true;
                }
            }

        },
        onContentReady: function (e) {
        },
        onOptionChanged: function (e) {
        },
        startDateExpr: 'fromUtc',
        endDateExpr: 'toUtc',
        appointmentTooltipTemplate: 'tooltip'
    };

    function openAddItemDialog(model) {

        addItemDialog.$promise.then(function () {

            if (model.rentCategory.rentingPeriodType == 1)
            {
                // Days
                addItemDialog.$scope.pickupTimeFromStr =
                    moment.utc(moment.duration(model.rentCategory.pickupTimeFrom || (12 * 60), 'minutes').as('milliseconds')).format('HH:mm');
                addItemDialog.$scope.pickupTimeToStr =
                    moment.utc(moment.duration(model.rentCategory.pickupTimeTo || (23 * 60 + 59), 'minutes').as('milliseconds')).format('HH:mm');

                addItemDialog.$scope.returnTimeFromStr =
                    moment.utc(moment.duration(model.rentCategory.returnTimeFrom || 0, 'minutes').as('milliseconds')).format('HH:mm');
                addItemDialog.$scope.returnTimeToStr =
                    moment.utc(moment.duration(model.rentCategory.returnTimeTo || (12 * 60), 'minutes').as('milliseconds')).format('HH:mm');
            }

            addItemDialog.$scope.model = model;
            addItemDialog.$scope.$on("modal.hide.before", function (evt, data) {
                if (!!selectedCells) {
                    selectedCells.removeClass('dx-state-selected');
                }
            });
            addItemDialog.show();
        });
    }

    var addItemDialog = $modal({
        templateUrl: 'rents/add-rent-item-dialog.html',
        show: false,
        backdrop: 'static',        
        scope: $scope.$new()
    });


    $scope.fromDateDateValidationRules = {
        validationRules: [{
            type: "required",
            message: $translate.instant('TXT_ERROR_REQUIRED')
        }]
    };

    $scope.fromDateTimeValidationRules = {
        validationRules: [{
            type: "required",
            message: $translate.instant('TXT_ERROR_REQUIRED')
        }]
    };

    $scope.toDateDateValidationRules = {
        validationRules: [{
            type: "required",
            message: $translate.instant('TXT_ERROR_REQUIRED')
        }]
    };

    $scope.toDateTimeValidationRules = {
        validationRules: [{
            type: "required",
            message: $translate.instant('TXT_ERROR_REQUIRED')
        }]
    };

    $scope.fromDateDateConfig = {
        type: "date",
        pickerType: "calendar",        
        bindingOptions: {
            value: "model.startDate",
            readOnly: "cart.startDate"
        }
    };

    $scope.fromDateTimeConfig = {
        type: "time",
        pickerType: "list",
        bindingOptions: {
            value: "model.startDate",
            readOnly: "cart.startDate"
        }
    };

    $scope.toDateDateConfig = {
        type: "date",
        pickerType: "calendar",
        bindingOptions: {
            value: "model.endDate",
            readOnly: "cart.startDate"
        }

    };

    $scope.toDateTimeConfig = {
        type: "time",
        pickerType: "list",
        bindingOptions: {
            value: "model.endDate",
            readOnly: "cart.startDate"
        }
    };

    $scope.onAddRentItmeToCart = function (model, hideFn) {
        var validationGroup = $("#addRentItemValidationGroup").dxValidationGroup("instance");
        const res = DevExpress.validationEngine.validateGroup(validationGroup);
        // For async validation
        //res.status === "pending" && res.complete.then((r) => {
        //    console.log(r.status);
        //});
        if (res.isValid) {
            shoppingCartSvc.addRentItemToShoppingCart($scope.cart, model, $scope.placeId);
            schedulerInstance.repaint();

            //schedulerInstance.addAppointment({
            //    text: 'XXX',
            //    startDate: model.startDate,
            //    endDate: model.endDate,
            //});
            hideFn();
        }
    }



    $scope.onItemTypeChange = function (itemTypeId) {

        localStorageService.set('selected-item-type-' + $scope.rentCategoryId, itemTypeId);

        $scope.rentCategory.$promise.then(function () {

            // Initial load
            if (originalItemTypeId != itemTypeId && !!itemTypeId) {
                originalItemTypeId = null;
                scheduleDataSource.load();
            }

            if (!!itemTypeId) {
                itemTypes.$promise.then(function () {
                    $scope.selectedItemType = _.find(itemTypes, { id: itemTypeId });
                    if ($scope.rentCategory.itemSelectionType == 0) { /* Manual */
                        schedulerInstance.option("resources", schedulerInstance.option("resources"));
                    }
                });
            } else {
                $scope.selectedItemType = {};
            }
        });
    }

    $scope.$on('onRentShoppingCartSaved', function (event, data) {
        repaintAfterReload = true;
        reloadData = true;
        scheduleDataSource.load();
    });


    $scope.$on('onRemoveItemFromShoppingCart', function (event, data) {
        schedulerInstance.repaint();
    });


}]);